import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button } from 'antd';
import GridView from '../../../components/elements/GridView/index';
import { getPaginationTotal } from '../../../components/elements/GridView/GridViewBase/Pagination';
import { formatTimesheetReportData } from '../../../core/utils/reportUtils';
import CustomEmpty, { CustomEmptyType } from '../../../components/CustomEmpty';
import Spinner from '../../../components/Spinner';

class DriverJourneyHistoryTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    onPageChange = (page, pageSize) => {
        const { onPageChange } = this.props;

        onPageChange(page, pageSize);
    };

    onTableChange = (pagination, filters, sorter, extra) => {
        const { onTableChange, driverJourneysPagination } = this.props;
        
        // If the user is on the same page, call onTableChange
        if (pagination && pagination.current === driverJourneysPagination.currentPage) {
            onTableChange(pagination, filters, sorter, extra);
        }
    };

    onExportCSV = () => {
        this.props.onExportJourneyHistoryCSV();
    };

    render() {
        const {
            driverJourneys,
            driverJourneysPagination,
            isLoadingJourneys,
            isExportingJourneyHistoryCsv,
            uomPreference,
            companyFeatures,
        } = this.props;

        if (!driverJourneys || driverJourneys.length === 0 && !isLoadingJourneys) {
            return <CustomEmpty showIcon type={CustomEmptyType.Report}/>;
        }

        let listAssetJourneys = formatTimesheetReportData(
            driverJourneys,
            uomPreference,
            'journeys',
            isLoadingJourneys,
            companyFeatures,
        );

        return (
            <>
                <Spinner 
                    loading={isLoadingJourneys} 
                    minHeight={200}
                >
                    {listAssetJourneys && listAssetJourneys.length > 0 && (
                        <>
                            <Button
                                type="primary"
                                className="export-csv-button"
                                onClick={this.onExportCSV}
                                loading={isExportingJourneyHistoryCsv}
                                data-testid='driver-details-journeys_export-btn'
                            >
                                Export
                            </Button>
                            <br/>
                        </>
                    )}
                    <div style={{ opacity: isLoadingJourneys ? 0 : 1 }}>
                        <GridView
                            data={listAssetJourneys && listAssetJourneys.length > 0 ? listAssetJourneys : []}
                            onChange={this.onTableChange}
                            sortableColumns={['driver', 'division', 'registration', 'start_date', 'end_date', 'shift', 'time_driven', 'idle_time', 'true_idle', 'mileage_Km', 'avg_speed_Km', 'max_speed_Km']}
                            hiddenColumns={['id', 'asset_id', 'driver_id', 'action']}
                            pagination={{
                                total: parseInt(driverJourneysPagination.totalRecords, 10),
                                showSizeChanger: false,
                                pageSize: parseInt(driverJourneysPagination.perPageCount, 10),
                                onChange: this.onPageChange,
                                showTotal: getPaginationTotal,
                            }}
                        />
                    </div>
                </Spinner>
            </>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DriverJourneyHistoryTab);
